import React, { useState } from 'react';

const MODAL_CONTENT = {
  about: {
    title: 'About us',
    body: 'We are a team dedicated to help beginners to optimize an investment portfolio.',
  },
  howToUse: {
    title: 'How to use',
    body: `1. Choose a selection strategy (Diversified is recommended).
2. Set your target beta (risk level from 0.1 to 3.0).
3. Optionally set a target return (%) or number of stocks.
4. Click "Optimize Portfolio" to get suggested weights.
5. Review the results: expected return, volatility, Sharpe ratio, and stock weights.`,
  },
  disclaimer: {
    title: 'Disclaimer',
    body: 'This page is not intended to give financial advice. It is created for educational purposes only. Past performance does not guarantee future results.',
  },
};

function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;
  return (
    <div id="footer-modal-overlay" className="footer-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="footer-modal-title">
      <div id="footer-modal" className="footer-modal" onClick={(e) => e.stopPropagation()}>
        <div id="footer-modal-header" className="footer-modal-header">
          <h2 id="footer-modal-title">{title}</h2>
          <button type="button" id="footer-modal-close" className="footer-modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div id="footer-modal-body" className="footer-modal-body">{children}</div>
      </div>
    </div>
  );
}

export default function Footer() {
  const [openModal, setOpenModal] = useState(null);

  return (
    <footer id="app-footer" className="app-footer">
      <div id="footer-links" className="footer-links">
        <button type="button" id="footer-link-about" className="footer-link" onClick={() => setOpenModal('about')}>About us</button>
        <span id="footer-sep-1" className="footer-sep">|</span>
        <button type="button" id="footer-link-how-to-use" className="footer-link" onClick={() => setOpenModal('howToUse')}>How to use</button>
        <span id="footer-sep-2" className="footer-sep">|</span>
        <button type="button" id="footer-link-disclaimer" className="footer-link" onClick={() => setOpenModal('disclaimer')}>Disclaimer</button>
      </div>
      <p id="footer-credit" className="footer-credit">Created By <a href="https://integradigital.pro" target="_blank" rel="noopener noreferrer">IntegraDigital</a></p>

      <Modal
        isOpen={openModal === 'about'}
        onClose={() => setOpenModal(null)}
        title={MODAL_CONTENT.about.title}
      >
        <p>{MODAL_CONTENT.about.body}</p>
      </Modal>
      <Modal
        isOpen={openModal === 'howToUse'}
        onClose={() => setOpenModal(null)}
        title={MODAL_CONTENT.howToUse.title}
      >
        <pre className="footer-modal-pre">{MODAL_CONTENT.howToUse.body}</pre>
      </Modal>
      <Modal
        isOpen={openModal === 'disclaimer'}
        onClose={() => setOpenModal(null)}
        title={MODAL_CONTENT.disclaimer.title}
      >
        <p>{MODAL_CONTENT.disclaimer.body}</p>
      </Modal>
    </footer>
  );
}
